export default __webpack_public_path__ + "static/media/oldeuropean-diagram-top.418c6b34.svg";